import { render, staticRenderFns } from "./Rotas.vue?vue&type=template&id=36b6a9e8&"
import script from "./Rotas.vue?vue&type=script&lang=js&"
export * from "./Rotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports